import { render } from "./lessonAdd.vue?vue&type=template&id=bc9c78a4&scoped=true"
import script from "./lessonAdd.vue?vue&type=script&lang=js"
export * from "./lessonAdd.vue?vue&type=script&lang=js"

import "./lessonAdd.vue?vue&type=style&index=0&id=bc9c78a4&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc9c78a4"]])

export default __exports__